<div class="backoffice-info" *ngIf="showInfo">
  <!-- Configuration Status Info -->
  <div class="backoffice-info__container backoffice-info__container--info" *ngIf="infoType === 'config'">
    <mat-icon class="backoffice-info__icon">info</mat-icon>
    <div class="backoffice-info__content">
      <h3 class="backoffice-info__title">{{ 'backoffice.configInProgress' | transloco }}</h3>
      <p class="backoffice-info__text">
        {{ 'backoffice.configInProgressMessage' | transloco }}
      </p>
    </div>
    <mat-icon class="backoffice-info__close" (click)="closeInfo()">close</mat-icon>
  </div>
</div>
